module.exports = __webpack_public_path__ + "static/media/3040161000_01.26a86a53.jpg";